const componentToHex = c => {
  const hex = c.toString(16);
  return hex.length === 1 ? `0${hex}` : hex;
};

const rgb2Hex = (r, g, b) =>
  `#${componentToHex(r)}${componentToHex(g)}${componentToHex(b)}`;

const hexToRGBA = (hex, alpha = 0.5) => {
  let c;
  if (/^#([A-Fa-f0-9]{3}){1,2}$/.test(hex)) {
    c = hex.substring(1).split("");
    if (c.length === 3) {
      c = [c[0], c[0], c[1], c[1], c[2], c[2]];
    }
    c = `0x${c.join("")}`;
    return `rgba(${(c >> 16) & 255},${(c >> 8) & 255},${c & 255},${alpha})`;
  } else {
    // console.error("Bad Hex:", hex, "Alpha: ", alpha);
    return false;
  }
};

const isColor = color => {
  if (hex2RGB(color)) return true;
  else return false;
};

const hex2RGB = hex => {
  let c;
  if (/^#([A-Fa-f0-9]{3}){1,2}$/.test(hex)) {
    c = hex.substring(1).split("");
    if (c.length === 3) {
      c = [c[0], c[0], c[1], c[1], c[2], c[2]];
    }
    c = `0x${c.join("")}`;
    // eslint-disable-next-line no-bitwise
    return { r: (c >> 16) & 255, g: (c >> 8) & 255, b: c & 255 };
  } else {
    return false;
    // throw new Error("Bad Hex");
  }
};

// https://24ways.org/2010/calculating-color-contrast
// https://www.w3.org/WAI/ER/WD-AERT/#color-contrast
const getContrast = hexColor => {
  const rgb = hex2RGB(hexColor);
  if (rgb) {
    const yiq = (rgb.r * 299 + rgb.g * 587 + rgb.b * 114) / 1000;
    return yiq >= 128 ? "#000000" : "#FFFFFF";
  } else return false;
};

const variacion = (H, Z, value) => {
  return (H / Z) * value;
};

// https://www.w3.org/TR/WCAG20/#relativeluminancedef
const colorBrightness = (color, value) => {
  const rgb = hex2RGB(color);
  const t = {};
  if (rgb) {
    if (value < 0) {
      t.r = rgb.r - parseInt((rgb.r / 100) * -value, 10);
      t.g = rgb.g - parseInt((rgb.g / 100) * -value, 10);
      t.b = rgb.b - parseInt((rgb.b / 100) * -value, 10);
    } else {
      t.r = parseInt(variacion(255 - rgb.r, 100, value), 10) + rgb.r;
      t.g = parseInt(variacion(255 - rgb.g, 100, value), 10) + rgb.g;
      t.b = parseInt(variacion(255 - rgb.b, 100, value), 10) + rgb.b;
    }
    return rgb2Hex(t.r, t.g, t.b);
  } else return false;
};

/**
 * Function to generate a colors palette.
 * This function return a array of colors
 * in the following format: [{color: 'string', textColor: 'string', name: 'string' }]
 * @param {string} hexColor Color in hexadecimal format
 * @param {string} name Name of color
 * @param {integer} cantShape Cant of variations
 */
const generatePalette = (hexColor, name, cantShape = 22) => {
  const step = 100 / Math.ceil(cantShape / 2);
  const startVal = step * Math.floor(cantShape / 2);
  const colors = [];
  if (isColor(hexColor)) {
    for (let i = 0; i < cantShape; i += 1) {
      const color = colorBrightness(hexColor, startVal - i * step);
      const textColor = getContrast(color);
      let tmpName;
      if (i > cantShape / 2) tmpName = `${name}-${i}`;
      else if (i === cantShape / 2) tmpName = name;
      else tmpName = `${name}-${i + 1}`;
      colors.push({
        name: tmpName,
        color,
        textColor
      });
    }
  }
  return colors;
};

export { generatePalette, getContrast, hex2RGB, hexToRGBA, rgb2Hex, isColor };
